import type { SVGProps } from "react"
const ShoppingBag = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.02469 7H5C3.89543 7 3 7.89543 3 9V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V9C21 7.89543 20.1046 7 19 7H16.9753C16.7245 4.47334 14.5927 2.5 12 2.5C9.40733 2.5 7.27555 4.47334 7.02469 7ZM9.04148 7H14.9585C14.7205 5.58114 13.4865 4.5 12 4.5C10.5135 4.5 9.27952 5.58114 9.04148 7ZM5 9V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V9H5Z"
      fill="currentColor"
    />
  </svg>
)
export default ShoppingBag
